import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../../hoc/Aux';
import axios from '../../axios-ns';
import * as messages from '../../messages';

class SignIn extends Component {
    state = {
        error: null,
        loading: false,
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: messages.YOUR_EMAIL
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: messages.PASSWORD
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        }
    };

    checkValidity(value, rules) {
        let isValid = true;

        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName.validation]),
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.authenticate(this.state.controls.email.value, this.state.controls.password.value);
    }

    authenticate = (email, password) => {
        this.setState({ ...this.state, loading: true });
        const authData = {
            email: email,
            password: password
        }

        let url = 'authenticate';

        axios.post(url, authData)
            .then(response => {
                const expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 10);
                localStorage.setItem('token', response.data);
                localStorage.setItem('expirationDate', expirationDate);

                this.setState({ ...this.state, isAuthenticated: true, error: null, loading: false });
                setInterval(() => {
                    if (new Date() >= new Date(localStorage.getItem('expirationDate'))) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('expirationDate');
                        this.props.history.replace('/signin');
                    }
                }, 1000 * 60 * 30);
            })
            .catch(err => {
                this.setState({ ...this.state, error: messages.INCORRECT_EMAIL_OR_PASSWORD, loading: false });
            });
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let errorMessage = null;

        if (this.state.error) {
            errorMessage = (
                <p style={{ color: 'orange', padding: '20px' }}>{this.state.error}</p>
            )
        }

        let view = null;
        if (this.state.isAuthenticated) {
            view = <Redirect to='/protected/dashboard' />
        } else {
            view = (<Card style={{width: '100%'}}>
                <CardHeader title={messages.SIGNIN} className={classes.Head} />
                {errorMessage}
                <form onSubmit={this.submitHandler} style={{padding: '10px', width: '100%'}}>
                    {form}
                    <p style={{textAlign: 'center'}}>
                    <Button color="primary" variant="contained" type="submit" style={{ marginBottom: '35px', backgroundColor: 'orange' }}>
                        {messages.SIGNIN}
                    </Button>
                    </p>
                    <p>{messages.DONT_HAVE_ACCOUNT}
                        <Button
                            color="primary"
                            className={classes.Link}
                            href='signup'>{messages.SIGNUP}
                        </Button>
                    </p>
                    <p>{messages.DONT_REMEMBER_PASSWORD}
                        <Button
                            color="primary"
                            className={classes.Link}
                            href='reset-password'>{messages.RESET_PASSWORD}
                        </Button>
                    </p>
                </form>
            </Card>
            );
        }

        if (this.state.loading) {
            view = <Spinner />
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default SignIn; 